exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inline[data-v-5e3ac208] {\n  display: inline-block;\n}\nbutton[data-v-5e3ac208] {\n  opacity: 0.8;\n}\nbutton[data-v-5e3ac208]:hover {\n    opacity: 1;\n}\nbutton.spaced[data-v-5e3ac208] {\n    margin-right: 6px;\n    color: #172b43;\n    opacity: .75;\n}\nbutton.spaced[data-v-5e3ac208]:hover {\n      opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5e3ac208","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/elements/dTooltip.vue
// module id = 574
// module chunks = 0